"use client";

import Link from "next/link";
import { useState, useRef, useEffect, useMemo } from "react";
import { useMenusContext } from "@core/helpers/client/contexts/MenusContext";
import { to_nested } from "@core/helpers/array";
import { normalize_blog_url } from "@/helpers/blogUrl";
import { ChevronLeft, Flame, Store, Menu, BadgePercent, BadgeHelp, } from "lucide-react";

const MAIN_HOVER_DELAY = 150;
const SUB_HOVER_DELAY = 250;
const CLOSE_DELAY = 200;
const MEGA_TRANSITION = 200;
// ردیف دوم هدر با اسکرول باز و بسته می‌شود (۵۰۰ms)؛ تا این مدت بعد از اسکرول هاور نادیده گرفته می‌شود
const SCROLL_HOVER_LOCK = 600;
const MEGA_WIDTH_STYLE = { "--mega-width": "min(1000px, calc(100vw - 60px))" };

const categoryHoverIcons = {
  woman: {
    fill: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M18.7497 22C18.8738 21.9999 18.9959 21.9691 19.1051 21.9103C19.2143 21.8514 19.3072 21.7664 19.3755 21.6628C19.4438 21.5592 19.4853 21.4403 19.4964 21.3167C19.5074 21.1931 19.4876 21.0687 19.4388 20.9547L14.9997 11.5L17.1428 8.13625C17.2129 8.01961 17.2499 7.88609 17.2499 7.75C17.2499 7.61392 17.2129 7.4804 17.1428 7.36375L15 4.30188L14.3434 5.125C14.0624 5.47674 13.7058 5.76071 13.3001 5.95586C12.8944 6.15102 12.4499 6.25235 11.9997 6.25235C11.5495 6.25235 11.105 6.15102 10.6993 5.95586C10.2936 5.76071 9.93697 5.47674 9.65594 5.125L9 4.30188L6.85656 7.36375C6.78648 7.4804 6.74946 7.61392 6.74946 7.75C6.74946 7.88609 6.78648 8.01961 6.85656 8.13625L8.99969 11.5L4.56156 20.9547C4.51274 21.0687 4.49294 21.193 4.50393 21.3165C4.51492 21.44 4.55635 21.5588 4.62453 21.6624C4.69271 21.766 4.7855 21.851 4.89459 21.9099C5.00369 21.9688 5.1257 21.9998 5.24969 22H18.7497Z"
          fill="#171717"
        />
        <path
          d="M15 4.30188V1.75M15 4.30188L17.1428 7.36375C17.2129 7.4804 17.2499 7.61392 17.2499 7.75C17.2499 7.88609 17.2129 8.01961 17.1428 8.13625L14.9997 11.5M15 4.30188L14.3434 5.125C14.0624 5.47674 13.7058 5.76071 13.3001 5.95586C12.8944 6.15102 12.4499 6.25235 11.9997 6.25235C11.5495 6.25235 11.105 6.15102 10.6993 5.95586C10.2936 5.76071 9.93697 5.47674 9.65594 5.125L9 4.30188M9 1.75V4.30188M9 4.30188L6.85656 7.36375C6.78648 7.4804 6.74946 7.61392 6.74946 7.75C6.74946 7.88609 6.78648 8.01961 6.85656 8.13625L8.99969 11.5M14.9997 11.5L19.4388 20.9547C19.4876 21.0687 19.5074 21.1931 19.4964 21.3167C19.4853 21.4403 19.4438 21.5592 19.3755 21.6628C19.3072 21.7664 19.2143 21.8514 19.1051 21.9103C18.9959 21.9691 18.8738 21.9999 18.7497 22H5.24969C5.1257 21.9998 5.00369 21.9688 4.89459 21.9099C4.7855 21.851 4.69271 21.766 4.62453 21.6624C4.55635 21.5588 4.51492 21.44 4.50393 21.3165C4.49294 21.193 4.51274 21.0687 4.56156 20.9547L8.99969 11.5M14.9997 11.5H8.99969"
          stroke="#171717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    outline: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M15 4.30188V1.75M15 4.30188L17.1428 7.36375C17.2129 7.4804 17.2499 7.61392 17.2499 7.75C17.2499 7.88609 17.2129 8.01961 17.1428 8.13625L14.9997 11.5M15 4.30188L14.3434 5.125C14.0624 5.47674 13.7058 5.76071 13.3001 5.95586C12.8944 6.15102 12.4499 6.25235 11.9997 6.25235C11.5495 6.25235 11.105 6.15102 10.6993 5.95586C10.2936 5.76071 9.93697 5.47674 9.65594 5.125L9 4.30188M9 1.75V4.30188M9 4.30188L6.85656 7.36375C6.78648 7.4804 6.74946 7.61392 6.74946 7.75C6.74946 7.88609 6.78648 8.01961 6.85656 8.13625L8.99969 11.5M14.9997 11.5L19.4388 20.9547C19.4876 21.0687 19.5074 21.1931 19.4964 21.3167C19.4853 21.4403 19.4438 21.5592 19.3755 21.6628C19.3072 21.7664 19.2143 21.8514 19.1051 21.9103C18.9959 21.9691 18.8738 21.9999 18.7497 22H5.24969C5.1257 21.9998 5.00369 21.9688 4.89459 21.9099C4.7855 21.851 4.69271 21.766 4.62453 21.6624C4.55635 21.5588 4.51492 21.44 4.50393 21.3165C4.49294 21.193 4.51274 21.0687 4.56156 20.9547L8.99969 11.5M14.9997 11.5H8.99969"
          stroke="#171717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  man: {
    fill: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M20.3798 3.46L15.9998 2C15.9998 3.06087 15.5784 4.07828 14.8282 4.82843C14.0781 5.57857 13.0607 6 11.9998 6C10.9389 6 9.92151 5.57857 9.17137 4.82843C8.42122 4.07828 7.9998 3.06087 7.9998 2L3.6198 3.46C3.16718 3.61079 2.78337 3.91842 2.53765 4.32734C2.29193 4.73627 2.20047 5.21956 2.2798 5.69L2.8598 9.16C2.89787 9.39491 3.01848 9.60855 3.19994 9.76251C3.3814 9.91648 3.61182 10.0007 3.8498 10H5.9998V20C5.9998 21.1 6.8998 22 7.9998 22H15.9998C16.5302 22 17.0389 21.7893 17.414 21.4142C17.7891 21.0391 17.9998 20.5304 17.9998 20V10H20.1498C20.3878 10.0007 20.6182 9.91648 20.7997 9.76251C20.9811 9.60855 21.1017 9.39491 21.1398 9.16L21.7198 5.69C21.7991 5.21956 21.7077 4.73627 21.4619 4.32734C21.2162 3.91842 20.8324 3.61079 20.3798 3.46Z"
          fill="#171717"
          stroke="#171717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    outline: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M20.3798 3.46L15.9998 2C15.9998 3.06087 15.5784 4.07828 14.8282 4.82843C14.0781 5.57857 13.0607 6 11.9998 6C10.9389 6 9.92151 5.57857 9.17137 4.82843C8.42122 4.07828 7.9998 3.06087 7.9998 2L3.6198 3.46C3.16718 3.61079 2.78337 3.91842 2.53765 4.32734C2.29193 4.73627 2.20047 5.21956 2.2798 5.69L2.8598 9.16C2.89787 9.39491 3.01848 9.60855 3.19994 9.76251C3.3814 9.91648 3.61182 10.0007 3.8498 10H5.9998V20C5.9998 21.1 6.8998 22 7.9998 22H15.9998C16.5302 22 17.0389 21.7893 17.414 21.4142C17.7891 21.0391 17.9998 20.5304 17.9998 20V10H20.1498C20.3878 10.0007 20.6182 9.91648 20.7997 9.76251C20.9811 9.60855 21.1017 9.39491 21.1398 9.16L21.7198 5.69C21.7991 5.21956 21.7077 4.73627 21.4619 4.32734C21.2162 3.91842 20.8324 3.61079 20.3798 3.46Z"
          stroke="#171717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  child: {
    fill: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5777 2.25938C12.512 2.25594 12.4467 2.26981 12.3881 2.29959C12.3295 2.32937 12.2798 2.37402 12.2439 2.42907C11.2783 3.88875 11.2502 5.23032 11.2502 5.25C11.2506 5.36161 11.276 5.47172 11.3244 5.57229C11.3728 5.67286 11.443 5.76136 11.5299 5.83134C11.6169 5.90131 11.7184 5.951 11.827 5.97677C11.9356 6.00254 12.0485 6.00376 12.1577 5.98032C12.328 5.93952 12.4794 5.84205 12.587 5.70391C12.6947 5.56576 12.7522 5.39513 12.7502 5.22C12.7538 5.11742 12.7784 5.01666 12.8225 4.92397C12.8666 4.83128 12.9292 4.74862 13.0066 4.68113C13.0839 4.61363 13.1743 4.56273 13.2721 4.53158C13.3699 4.50042 13.473 4.48968 13.5752 4.5C13.7634 4.52186 13.9367 4.61295 14.0615 4.75557C14.1863 4.89818 14.2535 5.08211 14.2502 5.27157C14.2468 5.8683 14.0065 6.43927 13.5822 6.85885C13.1579 7.27843 12.5842 7.51227 11.9875 7.50891C11.3908 7.50555 10.8198 7.26528 10.4002 6.84095C9.98064 6.41662 9.74681 5.84299 9.75017 5.24625C9.75017 5.18719 9.7586 4.23563 10.2602 2.99625C10.2856 2.93283 10.2932 2.86368 10.2821 2.79626C10.2711 2.72883 10.2419 2.66571 10.1976 2.61369C10.1533 2.56168 10.0956 2.52275 10.0308 2.50112C9.96599 2.47949 9.89651 2.47597 9.82985 2.49094C7.62004 2.99854 5.65573 4.25932 4.27393 6.05697C2.89212 7.85462 2.17894 10.0771 2.25673 12.3431C2.43767 17.505 6.67798 21.6563 11.8427 21.7406C14.3904 21.7797 16.8522 20.8198 18.7011 19.0664C20.55 17.3131 21.639 14.9056 21.7351 12.3594C21.8311 9.81312 20.9266 7.33045 19.2151 5.44278C17.5036 3.5551 15.1211 2.41244 12.5777 2.25938ZM7.50017 11.9916C7.50017 11.7691 7.56615 11.5516 7.68976 11.3665C7.81338 11.1815 7.98908 11.0374 8.19465 10.9522C8.40022 10.8671 8.62642 10.8448 8.84464 10.8882C9.06287 10.9316 9.26333 11.0387 9.42066 11.1961C9.578 11.3534 9.68514 11.5539 9.72855 11.7721C9.77196 11.9903 9.74968 12.2165 9.66453 12.4221C9.57938 12.6277 9.43519 12.8034 9.25018 12.927C9.06518 13.0506 8.84767 13.1166 8.62517 13.1166C8.3268 13.1166 8.04065 12.998 7.82967 12.7871C7.61869 12.5761 7.50017 12.2899 7.50017 11.9916ZM15.0255 17.1263C14.1178 17.6921 13.0697 17.992 12.0002 17.992C10.9306 17.992 9.88249 17.6921 8.97485 17.1263C8.80653 17.0201 8.68727 16.8514 8.64331 16.6573C8.59936 16.4632 8.63431 16.2596 8.74048 16.0913C8.84665 15.9229 9.01534 15.8037 9.20944 15.7597C9.40354 15.7158 9.60715 15.7507 9.77548 15.8569C10.4435 16.2715 11.214 16.4911 12.0002 16.4911C12.7863 16.4911 13.5569 16.2715 14.2249 15.8569C14.3082 15.8043 14.4011 15.7687 14.4982 15.752C14.5953 15.7353 14.6948 15.7379 14.7909 15.7597C14.887 15.7815 14.9779 15.822 15.0583 15.8788C15.1388 15.9357 15.2073 16.0079 15.2599 16.0913C15.3124 16.1746 15.3481 16.2675 15.3647 16.3646C15.3814 16.4617 15.3788 16.5612 15.357 16.6573C15.3353 16.7534 15.2948 16.8443 15.2379 16.9247C15.181 17.0052 15.1088 17.0737 15.0255 17.1263ZM15.3752 13.1166C15.1527 13.1166 14.9352 13.0506 14.7502 12.927C14.5651 12.8034 14.421 12.6277 14.3358 12.4221C14.2507 12.2165 14.2284 11.9903 14.2718 11.7721C14.3152 11.5539 14.4223 11.3534 14.5797 11.1961C14.737 11.0387 14.9375 10.9316 15.1557 10.8882C15.3739 10.8448 15.6001 10.8671 15.8057 10.9522C16.0113 11.0374 16.187 11.1815 16.3106 11.3665C16.4342 11.5516 16.5002 11.7691 16.5002 11.9916C16.5002 12.2899 16.3816 12.5761 16.1707 12.7871C15.9597 12.998 15.6735 13.1166 15.3752 13.1166Z" fill="#171717" />
    </svg>,
    outline: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.625 16.125C13.8372 16.6152 12.9279 16.875 12 16.875C11.0721 16.875 10.1628 16.6152 9.375 16.125M11.6184 3.0075C10.125 4.88063 10.125 6.75 10.125 6.75C10.125 7.24728 10.3225 7.72419 10.6742 8.07583C11.0258 8.42746 11.5027 8.625 12 8.625C12.4973 8.625 12.9742 8.42746 13.3258 8.07583C13.6775 7.72419 13.875 7.24728 13.875 6.75M15 12H15.01M9 12H9.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#171717" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  },

  beauty: {
    fill: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M6 21H10.5C8.32891 15.8137 12 13.5 13 10H8H6C5.46957 10 4.96086 10.2107 4.58579 10.5858C4.21071 10.9609 4 11.4696 4 12V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21Z"
          fill="#171717"
        />
        <path
          d="M10.5 2V6M14 2H7C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4M8 10H6C5.46957 10 4.96086 10.2107 4.58579 10.5858C4.21071 10.9609 4 11.4696 4 12V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H10.5C8.32891 15.8137 12 13.5 13 10V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6H9C8.73478 6 8.48043 6.10536 8.29289 6.29289C8.10536 6.48043 8 6.73478 8 7V10ZM6 10H13M13 10H8M19.29 14.76C18.1231 13.802 17.3158 12.4764 17 11C16.6895 12.4785 15.8812 13.8057 14.71 14.76C13.56 15.68 13 16.8 13 17.95C13 20.17 14.8 22 17 22C19.2 22 21 20.17 21 17.95C21 16.79 20.43 15.69 19.29 14.76Z"
          stroke="#171717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    outline: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M10.5 2V6M14 2H7C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4M9.607 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V12C4 11.4696 4.21071 10.9609 4.58579 10.5858C4.96086 10.2107 5.46957 10 6 10H13V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6H9C8.73478 6 8.48043 6.10536 8.29289 6.29289C8.10536 6.48043 8 6.73478 8 7V10M19.29 14.76C18.1231 13.802 17.3158 12.4764 17 11C16.6895 12.4785 15.8812 13.8057 14.71 14.76C13.56 15.68 13 16.8 13 17.95C13 20.17 14.8 22 17 22C19.2 22 21 20.17 21 17.95C21 16.79 20.43 15.69 19.29 14.76Z"
          stroke="#171717"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
};

const iconMap = {
  flame: (
    <Flame
      size={20}
      className="text-jmt-neutral-500 group-hover:text-jmt-main"
    />
  ),
  mags: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      className="text-jmt-neutral-500 group-hover:text-jmt-main"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.9004 9.10001V16C12.9004 16 13.0004 18 11.1004 18.1H9.40039V17.1H10.7004C10.7004 17.1 11.5004 17.1 11.5004 16.1V9.10001"
        fill="currentColor"
      />
      <path
        d="M11.5996 7.39999V5.89999H12.8996V8.29999H9.09961V7.39999H11.5996Z"
        fill="currentColor"
      />
    </svg>
  ),
  amazing: (
    <BadgePercent
      size={20}
      className="text-jmt-neutral-500 group-hover:text-jmt-main"
    />
  ),
  faq: (
    <BadgeHelp
      size={20}
      className="text-jmt-neutral-500 group-hover:text-jmt-main"
    />
  ),
  jumentStore: (
    <Store
      size={20}
      className="text-jmt-red-700 group-hover:text-jmt-red-600"
    />
  ),
};

const NavbarShop = () => {

  const { menus } = useMenusContext();
  const menuItems = useMemo(() => {
    return to_nested(menus?.["product_categories"]);
  }, [menus]);


  const [isOpen, setIsOpen] = useState(false);
  const [activeMain, setActiveMain] = useState(null);
  const [activeSub, setActiveSub] = useState(null);
  const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);

  const mainHoverTimeout = useRef(null);
  const subHoverTimeout = useRef(null);
  const closeTimeout = useRef(null);
  const lastScrollAt = useRef(0);
  const lastPointer = useRef(null);

  const navbarRef = useRef(null);
  const megaRef = useRef(null);

  const mainColumnRef = useRef(null);
  const subColumnRef = useRef(null);
  const contentColumnRef = useRef(null);

  const contentColumns = useMemo(() => {
    const groups = activeSub?.children || [];
    const columns = [[], [], []];

    groups.forEach((group, index) => {
      columns[index % 3].push(group);
    });

    return columns;
  }, [activeSub]);
  const clearMainHoverTimeout = () => {
    if (mainHoverTimeout.current) {
      clearTimeout(mainHoverTimeout.current);
      mainHoverTimeout.current = null;
    }
  };

  const clearSubHoverTimeout = () => {
    if (subHoverTimeout.current) {
      clearTimeout(subHoverTimeout.current);
      subHoverTimeout.current = null;
    }
  };

  const clearCloseTimeout = () => {
    if (closeTimeout.current) {
      clearTimeout(closeTimeout.current);
      closeTimeout.current = null;
    }
  };

  const cancelAllHoverTimeouts = () => {
    clearMainHoverTimeout();
    clearSubHoverTimeout();
  };

  const freezeSubColumnsHover = () => {
    clearMainHoverTimeout();
  };

  const freezeContentColumnHover = () => {
    clearMainHoverTimeout();
    clearSubHoverTimeout();
  };

  const resetColumnsScroll = (...refs) => {
    refs.forEach((ref) => {
      if (ref.current) ref.current.scrollTop = 0;
    });
  };

  useEffect(() => {
    if (!isOpen) return;

    if (menuItems?.length) {
      const firstMain = menuItems[0];
      const firstSub = firstMain?.children?.[0] || null;

      setActiveMain(firstMain);
      setActiveSub(firstSub);
    }
  }, [isOpen, menuItems]);

  useEffect(() => {
    if (isOpen) {
      resetColumnsScroll(mainColumnRef, subColumnRef, contentColumnRef);
    }
  }, [isOpen]);

  useEffect(() => {
    resetColumnsScroll(subColumnRef, contentColumnRef);
  }, [activeMain?.id]);

  useEffect(() => {
    resetColumnsScroll(contentColumnRef);
  }, [activeSub?.id]);

  useEffect(() => {
    if (isOpen) {
      setIsBackdropBlurred(true);
      return;
    }

    const timeout = setTimeout(() => setIsBackdropBlurred(false), MEGA_TRANSITION);
    return () => clearTimeout(timeout);
  }, [isOpen]);

  useEffect(() => {
    return () => {
      cancelAllHoverTimeouts();
      clearCloseTimeout();
    };
  }, []);

  const openMenu = () => {
    clearCloseTimeout();
    setIsOpen(true);
  };

  /* وقتی ردیف دوم هدر با اسکرول زیر نشانگرِ ثابت می‌لغزد، مرورگر خودش رویداد هاور (با همان
     مختصات قبلی) می‌فرستد و مگامنو بدون حرکت ماوس روی محتوا (مثلا تب‌های صفحه‌ی محصول) باز
     می‌شد. پس فقط حرکت واقعی ماوس، آن هم کمی بعد از آخرین اسکرول، منو را باز می‌کند. */
  const handleNavbarPointer = (event) => {
    if (isOpen) {
      clearCloseTimeout();
      return;
    }

    const previous = lastPointer.current;
    const moved = !previous || previous.x !== event.clientX || previous.y !== event.clientY;
    if (!moved) return;
    if (performance.now() - lastScrollAt.current < SCROLL_HOVER_LOCK) return;
    openMenu();
  };

  useEffect(() => {
    const handleScroll = () => {
      lastScrollAt.current = performance.now();
    };
    // روی document بعد از هندلر ری‌اکت اجرا می‌شود، پس هندلر مختصات حرکت قبلی را می‌بیند
    const handlePointer = (event) => {
      lastPointer.current = { x: event.clientX, y: event.clientY };
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("mousemove", handlePointer, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousemove", handlePointer);
    };
  }, []);

  // منوی باز با اسکرول صفحه بسته می‌شود؛ وگرنه با جمع شدن هدر روی صفحه معلق می‌ماند
  useEffect(() => {
    if (!isOpen) return;

    const handleScroll = () => closeMenu();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isOpen]);

  const closeMenu = () => {
    clearCloseTimeout();
    cancelAllHoverTimeouts();
    setIsOpen(false);
    resetColumnsScroll(mainColumnRef, subColumnRef, contentColumnRef);
  };

  const handleMainHover = (cat) => {
    clearMainHoverTimeout();
    clearSubHoverTimeout();

    mainHoverTimeout.current = setTimeout(() => {
      setActiveMain(cat);
      setActiveSub(cat?.children?.[0] || null);
      mainHoverTimeout.current = null;
    }, MAIN_HOVER_DELAY);
  };

  const handleSubHover = (sub) => {
    clearSubHoverTimeout();

    subHoverTimeout.current = setTimeout(() => {
      setActiveSub(sub);
      subHoverTimeout.current = null;
    }, SUB_HOVER_DELAY);
  };

  const scheduleClose = () => {
    clearCloseTimeout();

    closeTimeout.current = setTimeout(() => {
      closeMenu();
    }, CLOSE_DELAY);
  };

  const isMovingTowardMenu = (e) => {
    if (!navbarRef.current || !megaRef.current) return false;

    const nav = navbarRef.current.getBoundingClientRect();
    const mega = megaRef.current.getBoundingClientRect();
    const buffer = 60;

    return (
      e.clientX >= mega.left - buffer &&
      e.clientX <= mega.right + buffer &&
      e.clientY >= nav.bottom &&
      e.clientY <= nav.bottom + buffer
    );
  };

  const handleNavbarLeave = (e) => {
    if (isMovingTowardMenu(e)) return;
    scheduleClose();
  };

  const activeMainHasChildren = !!activeMain?.children?.length;

  if (!menuItems?.length) return null;

  return (
    <div className="relative flex items-center gap-x-8 py-4">
      <div
        ref={navbarRef}
        onMouseMove={handleNavbarPointer}
        onMouseLeave={handleNavbarLeave}
        className="relative"
      >
        <button
          className={`flex cursor-pointer items-center gap-1 ${isOpen
            ? "text-jmt-main"
            : "text-jmt-neutral-500 hover:text-jmt-main"
            }`}
        >
          <Menu size={20} />
          <span className="text-sm font-bold">دسته‌بندی محصولات</span>
        </button>

        <div
          className={`fixed inset-0 top-[133px] z-30 bg-jmt-black/40 transition-opacity duration-200 ${isBackdropBlurred ? "backdrop-blur-sm" : ""} ${isOpen ? "opacity-100" : "pointer-events-none opacity-0"}`}
          onClick={closeMenu}
        />

        <div
          ref={megaRef}
          style={MEGA_WIDTH_STYLE}
          onMouseEnter={clearCloseTimeout}
          onMouseLeave={scheduleClose}
          className={`fixed right-5.5 top-[133px] z-50 h-[450px] origin-top overflow-hidden rounded-b-md border border-jmt-neutral-200 bg-jmt-white shadow-buttom-light transition-[width,opacity,transform] duration-200 ease-out motion-reduce:transition-none ${activeMainHasChildren ? "w-(--mega-width)" : "w-[200px]"
            } ${isOpen
              ? "pointer-events-auto translate-y-0 scale-100 opacity-100"
              : "pointer-events-none -translate-y-2 scale-95 opacity-0"
            }`}
        >
          <div className="grid h-full w-(--mega-width) grid-cols-[200px_200px_1fr] text-right contain-[layout_paint]">
            {/* column 1 */}
            <ul
              ref={mainColumnRef}
              className="w-full overflow-y-auto overscroll-y-contain border-l border-jmt-neutral-200 px-1  contain-[layout_paint]"
            >
              {menuItems.map((cat) => {
                const hasChildren = !!cat?.children?.length;
                const active = activeMain?.id === cat.id;

                const content = (
                  <div className="flex items-center gap-1">
                    <div className="relative h-6 w-6 shrink-0">
                      <span
                        className={`absolute inset-0 transition-opacity duration-200 ${active ? "opacity-0" : "opacity-100"
                          }`}
                      >
                        {categoryHoverIcons[cat?.icon]?.outline}
                      </span>
                      <span
                        className={`absolute inset-0 transition-opacity duration-200 ${active ? "opacity-100" : "opacity-0"
                          }`}
                      >
                        {categoryHoverIcons[cat?.icon]?.fill}
                      </span>
                    </div>
                    <span className="truncate">{cat.title}</span>
                  </div>
                );

                return (
                  <li key={cat.id}>
                    {hasChildren ? (
                      <button
                        onMouseEnter={() => handleMainHover(cat)}
                        className={`flex w-full cursor-pointer items-center justify-between rounded-md py-3 pr-1 pl-0 text-[13px] ${active ? "bg-jmt-neutral-100 font-bold" : "bg-white"
                          }`}
                      >
                        {content}
                        <ChevronLeft
                          size={18}
                          className={
                            active ? "text-jmt-main" : "text-jmt-neutral-500"
                          }
                        />
                      </button>
                    ) : (
                      <Link
                        href={cat?.link?.url || "#"}
                        onMouseEnter={() => handleMainHover(cat)}
                        onClick={closeMenu}
                        className={`flex w-full cursor-pointer items-center justify-between rounded-md py-3 pr-1 pl-0 text-[13px] ${active ? "bg-jmt-neutral-100 font-bold" : "bg-jmt-white"
                          }`}
                      >
                        {content}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>

            {/* column 2 */}
            <ul
              ref={subColumnRef}
              className="overflow-y-auto overscroll-y-contain border-l border-jmt-neutral-200 px-1 contain-[layout_paint]"
              onMouseEnter={freezeSubColumnsHover}
              onMouseLeave={clearSubHoverTimeout}
            >
              {activeMain?.children?.map((sub) => {
                const active = activeSub?.id === sub.id;

                return (
                  <li key={sub.id}>
                    <button
                      onMouseEnter={() => handleSubHover(sub)}
                      className={`flex w-full cursor-pointer items-center justify-between rounded-md py-3 pr-1 pl-0 text-[13px] ${active ? "bg-jmt-neutral-100 font-bold" : "bg-jmt-white"
                        }`}
                    >
                      <span className="truncate">{sub.title}</span>
                      <ChevronLeft
                        size={18}
                        className={
                          active ? "text-jmt-main" : "text-jmt-neutral-500"
                        }
                      />
                    </button>
                  </li>
                );
              })}
            </ul>

            {/* column 3 */}
            <div
              className="overflow-y-auto overscroll-y-contain px-1 contain-[layout_paint]"
              ref={contentColumnRef}
              onMouseEnter={freezeContentColumnHover}
            >
              {activeSub && (
                <div className="sticky top-0 z-10 bg-jmt-white py-2">
                  <Link
                    href={activeSub?.link?.url || "#"}
                    onClick={closeMenu}
                    className="flex gap-1 text-sm font-bold text-jmt-primary-800"
                  >
                    همه محصولات {activeSub.title}
                    <ChevronLeft size={18} />
                  </Link>
                </div>
              )}

              <div className="grid grid-cols-3 gap-3 pt-3">
                {contentColumns.map((column, columnIndex) => (
                  <div
                    key={columnIndex}
                    className="flex min-w-0 flex-col gap-3"
                  >
                    {column.map((group) => (
                      <div
                        key={group.id}
                        className="flex min-w-0 flex-col"
                      >
                        <Link
                          href={group?.link?.url || "#"}
                          onClick={closeMenu}
                          className="mb-3 flex items-center gap-1 text-[13px] font-bold text-jmt-main"
                        >
                          <span className="truncate">
                            {group.title}
                          </span>

                          <ChevronLeft
                            size={18}
                            className="shrink-0"
                          />
                        </Link>

                        <ul className="space-y-2">
                          {group?.children?.map((item) => (
                            <li key={item.id}>
                              <Link
                                href={item?.link?.url || "#"}
                                onClick={closeMenu}
                                className="block pr-3 text-[13px] text-jmt-neutral-500 hover:text-jmt-primary-800"
                              >
                                {item.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {menus?.["header-main-menu-shop"]?.map((item, index, arr) => {
        const isLast = index === arr.length - 1;
        const raw_url = item?.link?.url || "#";
        const is_magazine =
          item?.icon === "mags" || /^\/-?blogs?(\/|$)/.test(raw_url);
        // آدرس مجله در CMS خراب است (`/-blogs`)، پس قبل از رندر نرمال می‌شود
        const url = is_magazine ? normalize_blog_url(raw_url) : raw_url;

        return (
          <Link
            key={item?.id}
            href={url}
            {...(is_magazine ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            className={`group flex items-center gap-1 text-sm text-jmt-neutral-500 ${isLast ? "text-jmt-red-700" : ""
              }`}
          >
            {iconMap[item?.icon]}
            <span
              className={`group-hover:text-jmt-main ${isLast ? "group-hover:text-jmt-red-600" : ""
                }`}
            >
              {item?.title}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default NavbarShop;



